  var el = document.querySelectorAll('.js-swpCarousel');

  if (el) {
    var initSwiper = function initSwiper(element) {
      var config = JSON.parse(element.dataset.swpCarouselConfig);

      if (config.gridRows) {
        config.slidesPerGroup = config.itemsVisible * config.gridRows;
        config.gridRows = {
          rows: config.gridRows,
          fill: 'column'
        };
      }

      var carouselOptions = {
        slidesPerView: config.itemsVisible,
        slidesPerGroup: config.itemsVisible,
        spaceBetween: config.itemsGap,
        centeredSlidesBounds: config.centeredSlidesBounds,
        pagination: setPagination(config.pagination),
        rewind: config.rewind != null ? config.rewind : false,
        grid: false,
        watchSlidesProgress: true,
        centerInsufficientSlides: config.centerInsufficientSlides,
        breakpoints: setBreakpoints(config, config.extraBrkpoints),
        itemsControlActive:
          config.itemsControlActive != null ? config.itemsControlActive : false
      };

      var swiper = new Swiper(config.id, carouselOptions);

      if (config.itemsLenght > config.itemsVisible) {
        initNavigation(config.isNavigation, config.id, swiper);
      }

      if (carouselOptions.itemsControlActive) {
        swiper.on('update', function () {
          itemsControl(swiper, config.id);
        });
        swiper.on('resize', function () {
          itemsControl(swiper, config.id);
        });
      }
    }

    var launchSwiper = function launchSwiper() {
      el.forEach(function (elSwiper) {
        initSwiper(elSwiper);
      });
    }
  }

  function initNavigation(isNavigation, id, swiperInstance) {
    if (isNavigation === false) {
      return false;
    }

    // Init elements
    var swpCarousel = document.querySelector(id),
      swiperWrapper = swpCarousel.parentElement,
      nextButton = swiperWrapper.querySelector(
        '.swiper-arrows .swiper-button-next'
      ),
      prevButton = swiperWrapper.querySelector(
        '.swiper-arrows .swiper-button-prev'
      );

    if (
      swiperInstance.progress === 0 &&
      !prevButton.classList.contains('swiper-button-disabled')
    ) {
      prevButton.classList.add('swiper-button-disabled');
    }

    swiperInstance.on('update', function () {
      if (
        swiperInstance.progress === 0 &&
        !prevButton.classList.contains('swiper-button-disabled')
      ) {
        prevButton.classList.add('swiper-button-disabled');
      }
    });

    // handler onClick navigation
    nextButton.addEventListener('click', function () {
      swiperInstance.slideNext();
    });

    prevButton.addEventListener('click', function () {
      swiperInstance.slidePrev();
    });

    // handler state navigations buttons onSlideChange
    swiperInstance.on('slideChange', function () {
      if (swiperInstance.progress === 0) {
        prevButton.classList.add('swiper-button-disabled');
        nextButton.classList.remove('swiper-button-disabled');
      }

      if (swiperInstance.progress === 1) {
        nextButton.classList.add('swiper-button-disabled');
        prevButton.classList.remove('swiper-button-disabled');
      }

      if (swiperInstance.progress > 0 && swiperInstance.progress < 1) {
        prevButton.classList.remove('swiper-button-disabled');
        nextButton.classList.remove('swiper-button-disabled');
      }
    });
  }

  function setPagination(typeOfLayout) {
    var layoutsPagination = {
      decimal: {
        clickable: true,
        el: '.swiper-pagination',
        renderBullet: function (index, className) {
          return (
            '<span class="decimal ' + className + '">' + (index + 1) + '</span>'
          );
        }
      },
      dots: {
        clickable: true,
        el: '.swiper-pagination',
        renderBullet: function (index, className) {
          return '<span class="dots ' + className + '"></span>';
        }
      }
    };

    if (
      typeOfLayout === 'bullets' ||
      typeOfLayout === 'fraction' ||
      typeOfLayout === 'progressbar'
    ) {
      return {
        el: '.swiper-pagination',
        type: typeOfLayout
      };
    }

    return layoutsPagination[typeOfLayout] || false;
  }

  function setBreakpoints(config, extraBreakpoints) {
    var breakpoints = {
      768: {
        slidesPerView: config.itemsVisibleSm,
        slidesPerGroup: config.itemsVisibleSm,
        spaceBetween: config.itemsGapSm
      },
      1024: {
        slidesPerView: config.itemsVisibleLg,
        slidesPerGroup: config.itemsVisibleLg,
        spaceBetween: config.itemsGapLg,
        grid: config.gridRows != null ? config.gridRows : false
      }
    };

    if (extraBreakpoints) {
      breakpoints = Object.assign(breakpoints, extraBreakpoints);
    }

    return breakpoints;
  }

  function itemsControl(swiperInstance, id) {
    var countSlides = swiperInstance.slides.length;

    // Init elements
    var swpCarousel = document.querySelector(id),
      swiperWrapper = swpCarousel.parentElement,
      swpArrows = swiperWrapper.querySelector('.swiper-arrows');

    // filtrar por encima de cero, los carouseles que están
    // en tabs tienen un display none y marcan cero mientras no se cargan.
    if (countSlides <= 2 && countSlides > 0) {
      addClassHiddenArrows();
      if (countSlides === 2 && swiperInstance.params.slidesPerView === 1) {
        removeClassHiddenArrows();
      } else {
        addClassHiddenArrows();
      }
    }

    function addClassHiddenArrows() {
      if (swpArrows) {
        var containSwpArrows = swpArrows.classList.contains(
          'swiper-arrows--hidden'
        );
        if (!containSwpArrows) swpArrows.classList.add('swiper-arrows--hidden');
      }
    }
    function removeClassHiddenArrows() {
      if (swpArrows) {
        var containSwpArrows = swpArrows.classList.contains(
          'swiper-arrows--hidden'
        );
        if (containSwpArrows)
          swpArrows.classList.remove('swiper-arrows--hidden');
      }
    }
  }


export {
  initSwiper,
  launchSwiper
}
